import { render, staticRenderFns } from "./UserContactChat.vue?vue&type=template&id=74d50779&"
import script from "./UserContactChat.vue?vue&type=script&lang=js&"
export * from "./UserContactChat.vue?vue&type=script&lang=js&"
import style0 from "./UserContactChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports